export default {
  setNFLData (state, val) {
    state.$nflData = val
  },
  setProfileInfo (state, val) {
    state.$profile = val
  },
  setProfilesInfo (state, val) {
    state.$profiles = val
  },
  setFBUserModels (state, val) {
    state.fbUserModels = val
  },
  setFBTrackModels (state, val) {
    state.fbTrackModels = val
  },
  setAsNFLApp (state, val) {
    state.isNFLApp = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/nfl.js